export default "__VITE_ASSET__yy7GqTUb__"